import { ChevronRight, Home } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/utils/cn'

const routeNames = {
  '/': 'Dashboard',
  '/orders': 'Orders',
  '/customers': 'Customers',
  '/categories': 'Categories',
  '/transactions': 'Transactions',
  '/products/add': 'Add Product',
  '/admin/role': 'Admin Role',
}

export function Breadcrumbs({ className = '', ...props }) {
  const location = useLocation()
  const pathnames = location.pathname.split('/').filter((x) => x)

  const breadcrumbs = [
    { name: 'Dashboard', href: '/', isHome: true },
  ]

  let currentPath = ''
  pathnames.forEach((pathname, index) => {
    currentPath += `/${pathname}`
    const isLast = index === pathnames.length - 1
    const routeName = routeNames[currentPath] || pathname.charAt(0).toUpperCase() + pathname.slice(1)
    
    breadcrumbs.push({
      name: routeName,
      href: currentPath,
      isLast,
    })
  })

  // Remove duplicate dashboard breadcrumb
  if (breadcrumbs.length > 1 && breadcrumbs[0].href === breadcrumbs[1].href) {
    breadcrumbs.shift()
  }

  return (
    <nav className={cn('flex items-center space-x-1 text-sm', className)} {...props}>
      {breadcrumbs.map((breadcrumb, index) => (
        <div key={breadcrumb.href} className="flex items-center">
          {index > 0 && (
            <ChevronRight className="h-4 w-4 text-muted-foreground mx-1" />
          )}
          
          {breadcrumb.isLast ? (
            <span className="font-medium text-foreground">
              {breadcrumb.name}
            </span>
          ) : (
            <Link
              to={breadcrumb.href}
              className="flex items-center text-muted-foreground hover:text-foreground transition-colors"
            >
              {breadcrumb.isHome && <Home className="h-4 w-4 mr-1" />}
              {breadcrumb.name}
            </Link>
          )}
        </div>
      ))}
    </nav>
  )
}